// Filter data to generate filter URL slugs and sitemaps
const ENTIRE_SPACE = {
  unit_types: ['ENTIRE']
}
const PARTIAL_SPACE = {
  unit_types: ['PARTIAL']
}
const ROOM = {
  unit_types: ['SINGLE']
}

const APARTMENT = {
  unit_types: ['ENTIRE'],
  housing_types: ['HIGHRISE']
}
const HOUSE = {
  unit_types: ['ENTIRE'],
  housing_types: ['HOUSE']
}
const TOWNHOUSE = {
  unit_types: ['ENTIRE'],
  housing_types: ['TOWNHOUSE']
}

const BASEMENT = {
  unit_types: ['PARTIAL'],
  unit_subtypes: ['BASEMENT']
}
const LANEWAY = {
  unit_types: ['PARTIAL'],
  unit_subtypes: ['LANEWAY']
}
const GARDEN_SUITE = {
  unit_types: ['PARTIAL'],
  unit_subtypes: ['GARDEN_SUITE']
}

const MIN_PRICE_RANGE = 500
const MAX_PRICE_RANGE = 2000
const MAX_PRICE_RANGE_ROOMS = 1500
const PRICE_INTERVAL = 100

// In cases where there are multiple possible filter slugs for a combination of filters
// we look at the "rank" to determine which one to use - lower rank takes priority

const priceFilters = () => {
  let filters = []
  for (let i = MIN_PRICE_RANGE; i <= MAX_PRICE_RANGE; i = i + PRICE_INTERVAL) {
    filters.push({
      [`under-${i}`]: {
        slug: `under-${i}`,
        filters: { min_price: '0', max_price: i },
        rank: 1000
      },
      [`apartments-under-${i}`]: {
        slug: `apartments-under-${i}`,
        filters: {
          ...APARTMENT,
          min_price: '0',
          max_price: i
        },
        rank: 400
      },
      [`houses-under-${i}`]: {
        slug: `houses-under-${i}`,
        filters: {
          ...HOUSE,
          min_price: '0',
          max_price: i
        },
        rank: 400
      },
      [`townhouses-under-${i}`]: {
        slug: `townhouses-under-${i}`,
        filters: {
          ...TOWNHOUSE,
          min_price: '0',
          max_price: i
        },
        rank: 400
      }
    })
    if (i <= MAX_PRICE_RANGE_ROOMS) {
      filters.push({
        [`rooms-under-${i}`]: {
          slug: `rooms-under-${i}`,
          filters: {
            ...ROOM,
            min_price: '0',
            max_price: i
          },
          rank: 400
        }
      })
    }
  }
  return filters
}

const bedBathFilters = () => {
  return [
    {
      studios: {
        slug: 'studios',
        filters: { bedroom_count: ['0'] },
        rank: 700
      },
      '1-bedroom': {
        slug: '1-bedroom',
        filters: { bedroom_count: ['1'] },
        rank: 700
      },
      '2-bedroom': {
        slug: '2-bedroom',
        filters: { bedroom_count: ['2'] },
        rank: 700
      },
      '3-bedroom': {
        slug: '3-bedroom',
        filters: { bedroom_count: ['3'] },
        rank: 700
      },
      '4-bedroom': {
        slug: '4-bedroom',
        filters: { bedroom_count: ['4+'] },
        rank: 700
      },
      'studio-apartments': {
        slug: 'studio-apartments',
        filters: {
          bedroom_count: ['0'],
          ...APARTMENT
        },
        rank: 100
      },
      '1-bedroom-apartments': {
        slug: '1-bedroom-apartments',
        filters: { bedroom_count: ['1'], ...APARTMENT },
        rank: 100
      },
      '2-bedroom-apartments': {
        slug: '2-bedroom-apartments',
        filters: { bedroom_count: ['2'], ...APARTMENT },
        rank: 100
      },
      '3-bedroom-apartments': {
        slug: '3-bedroom-apartments',
        filters: { bedroom_count: ['3'], ...APARTMENT },
        rank: 100
      },
      '4-bedroom-apartments': {
        slug: '4-bedroom-apartments',
        filters: { bedroom_count: ['4+'], ...APARTMENT },
        rank: 100
      },
      '1-bedroom-houses': {
        slug: '1-bedroom-houses',
        filters: {
          bedroom_count: ['1'],
          ...HOUSE
        },
        rank: 100
      },
      '2-bedroom-houses': {
        slug: '2-bedroom-houses',
        filters: {
          bedroom_count: ['2'],
          ...HOUSE
        },
        rank: 100
      },
      '3-bedroom-houses': {
        slug: '3-bedroom-houses',
        filters: {
          bedroom_count: ['3'],
          ...HOUSE
        },
        rank: 100
      },
      '4-bedroom-houses': {
        slug: '4-bedroom-houses',
        filters: {
          bedroom_count: ['4+'],
          ...HOUSE
        },
        rank: 100
      },
      '1-bedroom-townhouses': {
        slug: '1-bedroom-townhouses',
        filters: {
          bedroom_count: ['1'],
          ...TOWNHOUSE
        },
        rank: 100
      },
      '2-bedroom-townhouses': {
        slug: '2-bedroom-townhouses',
        filters: {
          bedroom_count: ['2'],
          ...TOWNHOUSE
        },
        rank: 100
      },
      '3-bedroom-townhouses': {
        slug: '3-bedroom-townhouses',
        filters: {
          bedroom_count: ['3'],
          ...TOWNHOUSE
        },
        rank: 100
      },
      '4-bedroom-townhouses': {
        slug: '4-bedroom-townhouses',
        filters: {
          bedroom_count: ['4+'],
          ...TOWNHOUSE
        },
        rank: 100
      },
      '1-bedroom-1-bath': {
        slug: '1-bedroom-1-bath',
        filters: { bedroom_count: ['1'], bathroom_count: ['1'] },
        rank: 300
      },
      '1-bedroom-2-bath': {
        slug: '1-bedroom-2-bath',
        filters: { bedroom_count: ['1'], bathroom_count: ['2'] },
        rank: 300
      },
      '2-bedroom-1-bath': {
        slug: '2-bedroom-1-bath',
        filters: { bedroom_count: ['2'], bathroom_count: ['1'] },
        rank: 300
      },
      '2-bedroom-2-bath': {
        slug: '2-bedroom-2-bath',
        filters: { bedroom_count: ['2'], bathroom_count: ['2'] },
        rank: 300
      },
      '3-bedroom-1-bath': {
        slug: '3-bedroom-1-bath',
        filters: { bedroom_count: ['3'], bathroom_count: ['1'] },
        rank: 300
      },
      '3-bedroom-2-bath': {
        slug: '3-bedroom-2-bath',
        filters: { bedroom_count: ['3'], bathroom_count: ['2'] },
        rank: 300
      },
      '3-bedroom-3-bath': {
        slug: '3-bedroom-3-bath',
        filters: { bedroom_count: ['3'], bathroom_count: ['3+'] },
        rank: 300
      },
      '4-bedroom-2-bath': {
        slug: '4-bedroom-2-bath',
        filters: { bedroom_count: ['4+'], bathroom_count: ['2'] },
        rank: 300
      },
      '4-bedroom-3-bath': {
        slug: '4-bedroom-3-bath',
        filters: { bedroom_count: ['4+'], bathroom_count: ['3+'] },
        rank: 300
      },
      '1-bedroom-apartments-under-500': {
        slug: '1-bedroom-apartments-under-500',
        filters: {
          bedroom_count: ['1'],
          ...APARTMENT,
          min_price: '0',
          max_price: 500
        },
        rank: 80
      },
      '1-bedroom-apartments-under-1000': {
        slug: '1-bedroom-apartments-under-1000',
        filters: {
          bedroom_count: ['1'],
          ...APARTMENT,
          min_price: '0',
          max_price: 1000
        },
        rank: 80
      },
      '2-bedroom-apartments-under-1000': {
        slug: '2-bedroom-apartments-under-1000',
        filters: {
          bedroom_count: ['2'],
          ...APARTMENT,
          min_price: '0',
          max_price: 1000
        },
        rank: 80
      },
      '3-bedroom-houses-under-1000': {
        slug: '3-bedroom-houses-under-1000',
        filters: {
          bedroom_count: ['3'],
          ...HOUSE,
          min_price: '0',
          max_price: 1000
        },
        rank: 80
      },
      '1-bedroom-1-bath-apartments': {
        slug: '1-bedroom-1-bath-apartments',
        filters: { bedroom_count: ['1'], bathroom_count: ['1'], ...APARTMENT },
        rank: 75
      },
      '1-bedroom-2-bath-apartments': {
        slug: '1-bedroom-2-bath-apartments',
        filters: { bedroom_count: ['1'], bathroom_count: ['2'], ...APARTMENT },
        rank: 75
      },
      '2-bedroom-1-bath-apartments': {
        slug: '2-bedroom-1-bath-apartments',
        filters: { bedroom_count: ['2'], bathroom_count: ['1'], ...APARTMENT },
        rank: 75
      },
      '2-bedroom-2-bath-apartments': {
        slug: '2-bedroom-2-bath-apartments',
        filters: { bedroom_count: ['2'], bathroom_count: ['2'], ...APARTMENT },
        rank: 75
      },
      '2-bedroom-3-bath-apartments': {
        slug: '2-bedroom-3-bath-apartments',
        filters: { bedroom_count: ['2'], bathroom_count: ['3+'], ...APARTMENT },
        rank: 75
      },
      '3-bedroom-2-bath-apartments': {
        slug: '3-bedroom-2-bath-apartments',
        filters: { bedroom_count: ['3'], bathroom_count: ['2'], ...APARTMENT },
        rank: 75
      },
      '1-bedroom-1-bath-houses': {
        slug: '1-bedroom-1-bath-houses',
        filters: { bedroom_count: ['1'], bathroom_count: ['1'], ...HOUSE },
        rank: 75
      },
      '2-bedroom-1-bath-houses': {
        slug: '2-bedroom-1-bath-houses',
        filters: { bedroom_count: ['2'], bathroom_count: ['1'], ...HOUSE },
        rank: 75
      },
      '2-bedroom-2-bath-houses': {
        slug: '2-bedroom-2-bath-houses',
        filters: { bedroom_count: ['2'], bathroom_count: ['2'], ...HOUSE },
        rank: 75
      },
      '3-bedroom-1-bath-houses': {
        slug: '3-bedroom-1-bath-houses',
        filters: { bedroom_count: ['3'], bathroom_count: ['1'], ...HOUSE },
        rank: 75
      },
      '3-bedroom-2-bath-houses': {
        slug: '3-bedroom-2-bath-houses',
        filters: { bedroom_count: ['3'], bathroom_count: ['2'], ...HOUSE },
        rank: 75
      },
      '4-bedroom-2-bath-houses': {
        slug: '4-bedroom-2-bath-houses',
        filters: { bedroom_count: ['4+'], bathroom_count: ['2'], ...HOUSE },
        rank: 75
      },
      '2-bedroom-2-bath-townhouses': {
        slug: '2-bedroom-2-bath-townhouses',
        filters: { bedroom_count: ['2'], bathroom_count: ['2'], ...TOWNHOUSE },
        rank: 75
      },
      '2-bath-apartments': {
        slug: '2-bath-apartments',
        filters: { bathroom_count: ['2'], ...APARTMENT },
        rank: 490
      },
      '3-bath-apartments': {
        slug: '3-bath-apartments',
        filters: { bathroom_count: ['3+'], ...APARTMENT },
        rank: 490
      },
      '2-bath-houses': {
        slug: '2-bath-houses',
        filters: { bathroom_count: ['2'], ...HOUSE },
        rank: 490
      },
      '3-bath-houses': {
        slug: '3-bath-houses',
        filters: { bathroom_count: ['3+'], ...HOUSE },
        rank: 490
      }
    }
  ]
}

const petFilters = () => {
  return [
    {
      'pet-friendly': {
        slug: 'pet-friendly',
        filters: { pet_policy: ['ALLOWED'] },
        rank: 800
      },
      'dog-friendly': {
        slug: 'dog-friendly',
        filters: { pet_policy: ['DOGS_ALLOWED'] },
        rank: 800
      },
      'cat-friendly': {
        slug: 'cat-friendly',
        filters: { pet_policy: ['CATS_ALLOWED'] },
        rank: 800
      },
      'pet-friendly-apartments': {
        slug: 'pet-friendly-apartments',
        filters: { pet_policy: ['ALLOWED'], ...APARTMENT },
        rank: 200
      },
      'pet-friendly-houses': {
        slug: 'pet-friendly-houses',
        filters: { pet_policy: ['ALLOWED'], ...HOUSE },
        rank: 200
      },
      'pet-friendly-townhouses': {
        slug: 'pet-friendly-townhouses',
        filters: { pet_policy: ['ALLOWED'], ...TOWNHOUSE },
        rank: 200
      },
      'pet-friendly-rooms': {
        slug: 'pet-friendly-rooms',
        filters: { pet_policy: ['ALLOWED'], ...ROOM },
        rank: 200
      },
      'dog-friendly-apartments': {
        slug: 'dog-friendly-apartments',
        filters: { pet_policy: ['DOGS_ALLOWED'], ...APARTMENT },
        rank: 200
      },
      'dog-friendly-houses': {
        slug: 'dog-friendly-houses',
        filters: { pet_policy: ['DOGS_ALLOWED'], ...HOUSE },
        rank: 200
      },
      'dog-friendly-townhouses': {
        slug: 'dog-friendly-townhouses',
        filters: { pet_policy: ['DOGS_ALLOWED'], ...TOWNHOUSE },
        rank: 200
      },
      'dog-friendly-rooms': {
        slug: 'dog-friendly-rooms',
        filters: { pet_policy: ['DOGS_ALLOWED'], ...ROOM },
        rank: 200
      },
      'cat-friendly-apartments': {
        slug: 'cat-friendly-apartments',
        filters: { pet_policy: ['CATS_ALLOWED'], ...APARTMENT },
        rank: 200
      },
      'cat-friendly-houses': {
        slug: 'cat-friendly-houses',
        filters: { pet_policy: ['CATS_ALLOWED'], ...HOUSE },
        rank: 200
      },
      'cat-friendly-townhouses': {
        slug: 'cat-friendly-townhouses',
        filters: { pet_policy: ['CATS_ALLOWED'], ...TOWNHOUSE },
        rank: 200
      },
      'cat-friendly-rooms': {
        slug: 'cat-friendly-rooms',
        filters: { pet_policy: ['CATS_ALLOWED'], ...ROOM },
        rank: 200
      },
      'pet-friendly-short-term': {
        slug: 'pet-friendly-short-term',
        filters: { pet_policy: ['ALLOWED'], rental_type: ['SHORT_TERM'] },
        rank: 560
      },
      'pet-friendly-long-term': {
        slug: 'pet-friendly-long-term',
        filters: { pet_policy: ['ALLOWED'], rental_type: ['LONG_TERM'] },
        rank: 560
      },
      'dog-friendly-short-term': {
        slug: 'dog-friendly-short-term',
        filters: { pet_policy: ['DOGS_ALLOWED'], rental_type: ['SHORT_TERM'] },
        rank: 560
      },
      'dog-friendly-long-term': {
        slug: 'dog-friendly-long-term',
        filters: { pet_policy: ['DOGS_ALLOWED'], rental_type: ['LONG_TERM'] },
        rank: 560
      },
      'cat-friendly-short-term': {
        slug: 'cat-friendly-short-term',
        filters: { pet_policy: ['CATS_ALLOWED'], rental_type: ['SHORT_TERM'] },
        rank: 560
      },
      'cat-friendly-long-term': {
        slug: 'cat-friendly-long-term',
        filters: { pet_policy: ['CATS_ALLOWED'], rental_type: ['LONG_TERM'] },
        rank: 560
      },
      'pet-friendly-studios': {
        slug: 'pet-friendly-studios',
        filters: { pet_policy: ['ALLOWED'], bedroom_count: ['0'] },
        rank: 680
      },
      'pet-friendly-1-bedroom': {
        slug: 'pet-friendly-1-bedroom',
        filters: { pet_policy: ['ALLOWED'], bedroom_count: ['1'] },
        rank: 680
      },
      'pet-friendly-2-bedroom': {
        slug: 'pet-friendly-2-bedroom',
        filters: { pet_policy: ['ALLOWED'], bedroom_count: ['2'] },
        rank: 680
      },
      'pet-friendly-3-bedroom': {
        slug: 'pet-friendly-3-bedroom',
        filters: { pet_policy: ['ALLOWED'], bedroom_count: ['3'] },
        rank: 680
      },
      'pet-friendly-4-bedroom': {
        slug: 'pet-friendly-4-bedroom',
        filters: { pet_policy: ['ALLOWED'], bedroom_count: ['4+'] },
        rank: 680
      },
      'dog-friendly-studios': {
        slug: 'dog-friendly-studios',
        filters: { pet_policy: ['DOGS_ALLOWED'], bedroom_count: ['0'] },
        rank: 680
      },
      'dog-friendly-1-bedroom': {
        slug: 'dog-friendly-1-bedroom',
        filters: { pet_policy: ['DOGS_ALLOWED'], bedroom_count: ['1'] },
        rank: 680
      },
      'dog-friendly-2-bedroom': {
        slug: 'dog-friendly-2-bedroom',
        filters: { pet_policy: ['DOGS_ALLOWED'], bedroom_count: ['2'] },
        rank: 680
      },
      'dog-friendly-3-bedroom': {
        slug: 'dog-friendly-3-bedroom',
        filters: { pet_policy: ['DOGS_ALLOWED'], bedroom_count: ['3'] },
        rank: 680
      },
      'dog-friendly-4-bedroom': {
        slug: 'dog-friendly-4-bedroom',
        filters: { pet_policy: ['DOGS_ALLOWED'], bedroom_count: ['4+'] },
        rank: 680
      },
      'pet-friendly-studio-apartments': {
        slug: 'pet-friendly-studio-apartments',
        filters: {
          pet_policy: ['ALLOWED'],
          bedroom_count: ['0'],
          ...APARTMENT
        },
        rank: 85
      },
      'pet-friendly-1-bedroom-apartments': {
        slug: 'pet-friendly-1-bedroom-apartments',
        filters: {
          pet_policy: ['ALLOWED'],
          bedroom_count: ['1'],
          ...APARTMENT
        },
        rank: 85
      },
      'pet-friendly-2-bedroom-houses': {
        slug: 'pet-friendly-2-bedroom-houses',
        filters: { pet_policy: ['ALLOWED'], bedroom_count: ['2'], ...HOUSE },
        rank: 85
      },
      'pet-friendly-3-bedroom-houses': {
        slug: 'pet-friendly-3-bedroom-houses',
        filters: { pet_policy: ['ALLOWED'], bedroom_count: ['3'], ...HOUSE },
        rank: 85
      },
      'pet-friendly-4-bedroom-houses': {
        slug: 'pet-friendly-4-bedroom-houses',
        filters: { pet_policy: ['ALLOWED'], bedroom_count: ['4+'], ...HOUSE },
        rank: 85
      },
      'pet-friendly-furnished-short-term': {
        slug: 'pet-friendly-furnished-short-term',
        filters: {
          pet_policy: ['ALLOWED'],
          features: ['furnished'],
          rental_type: ['SHORT_TERM']
        },
        rank: 530
      }
    }
  ]
}
const leaseTypeFilters = () => {
  return [
    {
      'fixed-term-lease': {
        slug: 'fixed-term-lease',
        filters: { lease_type: 'FIXED' },
        rank: 1200
      },
      'month-to-month': {
        slug: 'month-to-month',
        filters: { lease_type: 'MONTH_TO_MONTH' },
        rank: 1200
      },
      'monthly-apartments': {
        slug: 'monthly-apartments',
        filters: { lease_type: 'MONTH_TO_MONTH', ...APARTMENT },
        rank: 480
      },
      'monthly-houses': {
        slug: 'monthly-houses',
        filters: { lease_type: 'MONTH_TO_MONTH', ...HOUSE },
        rank: 480
      },
      'monthly-townhouses': {
        slug: 'monthly-townhouses',
        filters: { lease_type: 'MONTH_TO_MONTH', ...TOWNHOUSE },
        rank: 480
      },
      'monthly-rooms': {
        slug: 'monthly-rooms',
        filters: { lease_type: 'MONTH_TO_MONTH', ...ROOM },
        rank: 480
      },
      'monthly-short-term': {
        slug: 'monthly-short-term',
        filters: { lease_type: 'MONTH_TO_MONTH', rental_type: ['SHORT_TERM'] },
        rank: 580
      },
      'monthly-studios': {
        slug: 'monthly-studios',
        filters: { lease_type: 'MONTH_TO_MONTH', bedroom_count: ['0'] },
        rank: 660
      },
      'monthly-1-bedroom': {
        slug: 'monthly-1-bedroom',
        filters: { lease_type: 'MONTH_TO_MONTH', bedroom_count: ['1'] },
        rank: 660
      },
      'monthly-2-bedroom': {
        slug: 'monthly-2-bedroom',
        filters: { lease_type: 'MONTH_TO_MONTH', bedroom_count: ['2'] },
        rank: 660
      },
      'monthly-3-bedroom': {
        slug: 'monthly-3-bedroom',
        filters: { lease_type: 'MONTH_TO_MONTH', bedroom_count: ['3'] },
        rank: 660
      },
      'monthly-4-bedroom': {
        slug: 'monthly-4-bedroom',
        filters: { lease_type: 'MONTH_TO_MONTH', bedroom_count: ['4+'] },
        rank: 660
      }
    }
  ]
}

const rentalTypeFilters = () => {
  return [
    {
      'short-term': {
        slug: 'short-term',
        filters: { rental_type: ['SHORT_TERM'] },
        rank: 600
      },
      'long-term': {
        slug: 'long-term',
        filters: { rental_type: ['LONG_TERM'] },
        rank: 600
      },
      'short-term-apartments': {
        slug: 'short-term-apartments',
        filters: { rental_type: ['SHORT_TERM'], ...APARTMENT },
        rank: 460
      },
      'short-term-houses': {
        slug: 'short-term-houses',
        filters: { rental_type: ['SHORT_TERM'], ...HOUSE },
        rank: 460
      },
      'short-term-townhouses': {
        slug: 'short-term-townhouses',
        filters: { rental_type: ['SHORT_TERM'], ...TOWNHOUSE },
        rank: 460
      },
      'short-term-rooms': {
        slug: 'short-term-rooms',
        filters: { rental_type: ['SHORT_TERM'], ...ROOM },
        rank: 460
      },
      'long-term-apartments': {
        slug: 'long-term-apartments',
        filters: { rental_type: ['LONG_TERM'], ...APARTMENT },
        rank: 460
      },
      'long-term-houses': {
        slug: 'long-term-houses',
        filters: { rental_type: ['LONG_TERM'], ...HOUSE },
        rank: 460
      },
      'long-term-townhouses': {
        slug: 'long-term-townhouses',
        filters: { rental_type: ['LONG_TERM'], ...TOWNHOUSE },
        rank: 460
      },
      'long-term-rooms': {
        slug: 'long-term-rooms',
        filters: { rental_type: ['LONG_TERM'], ...ROOM },
        rank: 460
      },
      'studio-short-term': {
        slug: 'studio-short-term',
        filters: { rental_type: ['SHORT_TERM'], bedroom_count: ['0'] },
        rank: 520
      },
      '1-bedroom-short-term': {
        slug: '1-bedroom-short-term',
        filters: { rental_type: ['SHORT_TERM'], bedroom_count: ['1'] },
        rank: 520
      },
      '2-bedroom-short-term': {
        slug: '2-bedroom-short-term',
        filters: { rental_type: ['SHORT_TERM'], bedroom_count: ['2'] },
        rank: 520
      },
      '3-bedroom-short-term': {
        slug: '3-bedroom-short-term',
        filters: { rental_type: ['SHORT_TERM'], bedroom_count: ['3'] },
        rank: 520
      },
      '4-bedroom-short-term': {
        slug: '4-bedroom-short-term',
        filters: { rental_type: ['SHORT_TERM'], bedroom_count: ['4+'] },
        rank: 520
      },
      'studio-long-term': {
        slug: 'studio-long-term',
        filters: { rental_type: ['LONG_TERM'], bedroom_count: ['0'] },
        rank: 520
      },
      '1-bedroom-long-term': {
        slug: '1-bedroom-long-term',
        filters: { rental_type: ['LONG_TERM'], bedroom_count: ['1'] },
        rank: 520
      },
      '2-bedroom-long-term': {
        slug: '2-bedroom-long-term',
        filters: { rental_type: ['LONG_TERM'], bedroom_count: ['2'] },
        rank: 520
      },
      '3-bedroom-long-term': {
        slug: '3-bedroom-long-term',
        filters: { rental_type: ['LONG_TERM'], bedroom_count: ['3'] },
        rank: 520
      },
      '4-bedroom-long-term': {
        slug: '4-bedroom-long-term',
        filters: { rental_type: ['LONG_TERM'], bedroom_count: ['4+'] },
        rank: 520
      },
      'short-term-studio-apartments': {
        slug: 'short-term-studio-apartments',
        filters: {
          rental_type: ['SHORT_TERM'],
          bedroom_count: ['0'],
          ...APARTMENT
        },
        rank: 95
      },
      'short-term-1-bedroom-apartments': {
        slug: 'short-term-1-bedroom-apartments',
        filters: {
          rental_type: ['SHORT_TERM'],
          bedroom_count: ['1'],
          ...APARTMENT
        },
        rank: 95
      },
      'short-term-2-bedroom-apartments': {
        slug: 'short-term-2-bedroom-apartments',
        filters: {
          rental_type: ['SHORT_TERM'],
          bedroom_count: ['2'],
          ...APARTMENT
        },
        rank: 95
      },
      'short-term-3-bedroom-apartments': {
        slug: 'short-term-3-bedroom-apartments',
        filters: {
          rental_type: ['SHORT_TERM'],
          bedroom_count: ['3'],
          ...APARTMENT
        },
        rank: 95
      }
    }
  ]
}

const featuresFilters = () => {
  return [
    {
      furnished: {
        slug: 'furnished',
        filters: { features: ['furnished'] },
        rank: 1100
      },
      unfurnished: {
        slug: 'unfurnished',
        filters: { features: ['unfurnished'] },
        rank: 1100
      },
      'furnished-apartments': {
        slug: 'furnished-apartments',
        filters: { features: ['furnished'], ...APARTMENT },
        rank: 440
      },
      'furnished-houses': {
        slug: 'furnished-houses',
        filters: { features: ['furnished'], ...HOUSE },
        rank: 440
      },
      'furnished-townhouses': {
        slug: 'furnished-townhouses',
        filters: { features: ['furnished'], ...TOWNHOUSE },
        rank: 440
      },
      'furnished-rooms': {
        slug: 'furnished-rooms',
        filters: { features: ['furnished'], ...ROOM },
        rank: 440
      },
      'unfurnished-apartments': {
        slug: 'unfurnished-apartments',
        filters: { features: ['unfurnished'], ...APARTMENT },
        rank: 440
      },
      'unfurnished-houses': {
        slug: 'unfurnished-houses',
        filters: { features: ['unfurnished'], ...HOUSE },
        rank: 440
      },
      'unfurnished-townhouses': {
        slug: 'unfurnished-townhouses',
        filters: { features: ['unfurnished'], ...TOWNHOUSE },
        rank: 440
      },
      'unfurnished-rooms': {
        slug: 'unfurnished-rooms',
        filters: { features: ['unfurnished'], ...ROOM },
        rank: 440
      },
      'furnished-short-term': {
        slug: 'furnished-short-term',
        filters: { features: ['furnished'], rental_type: ['SHORT_TERM'] },
        rank: 540
      },
      'unfurnished-short-term': {
        slug: 'unfurnished-short-term',
        filters: { features: ['unfurnished'], rental_type: ['SHORT_TERM'] },
        rank: 540
      },
      'furnished-long-term': {
        slug: 'furnished-long-term',
        filters: { features: ['furnished'], rental_type: ['LONG_TERM'] },
        rank: 540
      },
      'unfurnished-long-term': {
        slug: 'unfurnished-long-term',
        filters: { features: ['unfurnished'], rental_type: ['LONG_TERM'] },
        rank: 540
      },
      'furnished-studios': {
        slug: 'furnished-studios',
        filters: { features: ['furnished'], bedroom_count: ['0'] },
        rank: 450
      },
      'furnished-1-bedroom': {
        slug: 'furnished-1-bedroom',
        filters: { features: ['furnished'], bedroom_count: ['1'] },
        rank: 450
      },
      'furnished-2-bedroom': {
        slug: 'furnished-2-bedroom',
        filters: { features: ['furnished'], bedroom_count: ['2'] },
        rank: 450
      },
      'furnished-3-bedroom': {
        slug: 'furnished-3-bedroom',
        filters: { features: ['furnished'], bedroom_count: ['3'] },
        rank: 450
      },
      'furnished-4-bedroom': {
        slug: 'furnished-4-bedroom',
        filters: { features: ['furnished'], bedroom_count: ['4+'] },
        rank: 450
      },
      'unfurnished-studios': {
        slug: 'unfurnished-studios',
        filters: { features: ['unfurnished'], bedroom_count: ['0'] },
        rank: 450
      },
      'unfurnished-1-bedroom': {
        slug: 'unfurnished-1-bedroom',
        filters: { features: ['unfurnished'], bedroom_count: ['1'] },
        rank: 450
      },
      'unfurnished-2-bedroom': {
        slug: 'unfurnished-2-bedroom',
        filters: { features: ['unfurnished'], bedroom_count: ['2'] },
        rank: 450
      },
      'unfurnished-3-bedroom': {
        slug: 'unfurnished-3-bedroom',
        filters: { features: ['unfurnished'], bedroom_count: ['3'] },
        rank: 450
      },
      'unfurnished-4-bedroom': {
        slug: 'unfurnished-4-bedroom',
        filters: { features: ['unfurnished'], bedroom_count: ['4+'] },
        rank: 450
      },
      'furnished-pet-friendly': {
        slug: 'furnished-pet-friendly',
        filters: { features: ['furnished'], pet_policy: ['ALLOWED'] },
        rank: 780
      },
      'furnished-dog-friendly': {
        slug: 'furnished-dog-friendly',
        filters: { features: ['furnished'], pet_policy: ['DOGS_ALLOWED'] },
        rank: 780
      },
      'furnished-monthly': {
        slug: 'furnished-monthly',
        filters: { features: ['furnished'], lease_type: 'MONTH_TO_MONTH' },
        rank: 1080
      },
      'unfurnished-monthly': {
        slug: 'unfurnished-monthly',
        filters: { features: ['unfurnished'], lease_type: 'MONTH_TO_MONTH' },
        rank: 1080
      },
      'furnished-short-term-apartments': {
        slug: 'furnished-short-term-apartments',
        filters: {
          features: ['furnished'],
          rental_type: ['SHORT_TERM'],
          ...APARTMENT
        },
        rank: 430
      },
      'furnished-studio-apartments': {
        slug: 'furnished-studio-apartments',
        filters: {
          features: ['furnished'],
          bedroom_count: ['0'],
          ...APARTMENT
        },
        rank: 90
      },
      'furnished-1-bedroom-apartments': {
        slug: 'furnished-1-bedroom-apartments',
        filters: {
          features: ['furnished'],
          bedroom_count: ['1'],
          ...APARTMENT
        },
        rank: 90
      },
      'furnished-2-bedroom-apartments': {
        slug: 'furnished-2-bedroom-apartments',
        filters: {
          features: ['furnished'],
          bedroom_count: ['2'],
          ...APARTMENT
        },
        rank: 90
      },
      'furnished-3-bedroom-apartments': {
        slug: 'furnished-3-bedroom-apartments',
        filters: {
          features: ['furnished'],
          bedroom_count: ['3'],
          ...APARTMENT
        },
        rank: 90
      },
      'furnished-4-bedroom-houses': {
        slug: 'furnished-4-bedroom-houses',
        filters: {
          features: ['furnished'],
          bedroom_count: ['4+'],
          ...HOUSE
        },
        rank: 90
      },
      'unfurnished-studio-apartments': {
        slug: 'unfurnished-studio-apartments',
        filters: {
          features: ['unfurnished'],
          bedroom_count: ['0'],
          ...APARTMENT
        },
        rank: 90
      },
      'unfurnished-1-bedroom-apartments': {
        slug: 'unfurnished-1-bedroom-apartments',
        filters: {
          features: ['unfurnished'],
          bedroom_count: ['1'],
          ...APARTMENT
        },
        rank: 90
      },
      'unfurnished-2-bedroom-apartments': {
        slug: 'unfurnished-2-bedroom-apartments',
        filters: {
          features: ['unfurnished'],
          bedroom_count: ['2'],
          ...APARTMENT
        },
        rank: 90
      },
      'unfurnished-3-bedroom-apartments': {
        slug: 'unfurnished-3-bedroom-apartments',
        filters: {
          features: ['unfurnished'],
          bedroom_count: ['3'],
          ...APARTMENT
        },
        rank: 90
      }
    }
  ]
}

const amenitiesFilters = () => {
  return [
    {
      'washer-dryer': {
        slug: 'washer-dryer',
        filters: {
          features: ['insuite_laundry']
        },
        rank: 1400
      },
      'air-conditioning': {
        slug: 'air-conditioning',
        filters: {
          features: ['air_conditioning']
        },
        rank: 1400
      },
      dishwasher: {
        slug: 'dishwasher',
        filters: {
          features: ['dishwasher']
        },
        rank: 1400
      },
      parking: {
        slug: 'parking',
        filters: {
          features: ['parking']
        },
        rank: 1400
      },
      balcony: {
        slug: 'balcony',
        filters: {
          features: ['balcony']
        },
        rank: 1400
      },
      'gym-fitness-center': {
        slug: 'gym-fitness-center',
        filters: {
          features: ['gym']
        },
        rank: 1400
      },
      'swimming-pool': {
        slug: 'swimming-pool',
        filters: {
          features: ['pool']
        },
        rank: 1400
      },
      'wheelchair-access': {
        slug: 'wheelchair-access',
        filters: {
          features: ['disable_ready']
        },
        rank: 1400
      },
      'apartments-washer-dryer': {
        slug: 'apartments-washer-dryer',
        filters: {
          features: ['insuite_laundry'],
          ...APARTMENT
        },
        rank: 495
      },
      'houses-washer-dryer': {
        slug: 'houses-washer-dryer',
        filters: {
          features: ['insuite_laundry'],
          ...HOUSE
        },
        rank: 495
      },
      'townhouses-washer-dryer': {
        slug: 'townhouses-washer-dryer',
        filters: {
          features: ['insuite_laundry'],
          ...TOWNHOUSE
        },
        rank: 495
      },
      'rooms-washer-dryer': {
        slug: 'rooms-washer-dryer',
        filters: {
          features: ['insuite_laundry'],
          ...ROOM
        },
        rank: 495
      },
      'studios-washer-dryer': {
        slug: 'studios-washer-dryer',
        filters: {
          features: ['insuite_laundry'],
          bedroom_count: ['0']
        },
        rank: 690
      },
      '1-bedroom-washer-dryer': {
        slug: '1-bedroom-washer-dryer',
        filters: {
          features: ['insuite_laundry'],
          bedroom_count: ['1']
        },
        rank: 690
      },
      '2-bedroom-washer-dryer': {
        slug: '2-bedroom-washer-dryer',
        filters: {
          features: ['insuite_laundry'],
          bedroom_count: ['2']
        },
        rank: 690
      },
      '3-bedroom-washer-dryer': {
        slug: '3-bedroom-washer-dryer',
        filters: {
          features: ['insuite_laundry'],
          bedroom_count: ['3']
        },
        rank: 690
      },
      '4-bedroom-washer-dryer': {
        slug: '4-bedroom-washer-dryer',
        filters: {
          features: ['insuite_laundry'],
          bedroom_count: ['4+']
        },
        rank: 690
      },
      'apartments-air-conditioning': {
        slug: 'apartments-air-conditioning',
        filters: {
          features: ['air_conditioning'],
          ...APARTMENT
        },
        rank: 495
      },
      'houses-air-conditioning': {
        slug: 'houses-air-conditioning',
        filters: {
          features: ['air_conditioning'],
          ...HOUSE
        },
        rank: 495
      },
      'townhouses-air-conditioning': {
        slug: 'townhouses-air-conditioning',
        filters: {
          features: ['air_conditioning'],
          ...TOWNHOUSE
        },
        rank: 495
      },
      'rooms-air-conditioning': {
        slug: 'rooms-air-conditioning',
        filters: {
          features: ['air_conditioning'],
          ...ROOM
        },
        rank: 495
      },
      'studios-air-conditioning': {
        slug: 'studios-air-conditioning',
        filters: {
          features: ['air_conditioning'],
          bedroom_count: ['0']
        },
        rank: 690
      },
      '1-bedroom-air-conditioning': {
        slug: '1-bedroom-air-conditioning',
        filters: {
          features: ['air_conditioning'],
          bedroom_count: ['1']
        },
        rank: 690
      },
      '2-bedroom-air-conditioning': {
        slug: '2-bedroom-air-conditioning',
        filters: {
          features: ['air_conditioning'],
          bedroom_count: ['2']
        },
        rank: 690
      },
      '3-bedroom-air-conditioning': {
        slug: '3-bedroom-air-conditioning',
        filters: {
          features: ['air_conditioning'],
          bedroom_count: ['3']
        },
        rank: 690
      },
      '4-bedroom-air-conditioning': {
        slug: '4-bedroom-air-conditioning',
        filters: {
          features: ['air_conditioning'],
          bedroom_count: ['4+']
        },
        rank: 690
      },
      'apartments-dishwasher': {
        slug: 'apartments-dishwasher',
        filters: {
          features: ['dishwasher'],
          ...APARTMENT
        },
        rank: 495
      },
      'houses-dishwasher': {
        slug: 'houses-dishwasher',
        filters: {
          features: ['dishwasher'],
          ...HOUSE
        },
        rank: 495
      },
      'townhouses-dishwasher': {
        slug: 'townhouses-dishwasher',
        filters: {
          features: ['dishwasher'],
          ...TOWNHOUSE
        },
        rank: 495
      },
      'rooms-dishwasher': {
        slug: 'rooms-dishwasher',
        filters: {
          features: ['dishwasher'],
          ...ROOM
        },
        rank: 495
      },
      'studios-dishwasher': {
        slug: 'studios-dishwasher',
        filters: {
          features: ['dishwasher'],
          bedroom_count: ['0']
        },
        rank: 690
      },
      '1-bedroom-dishwasher': {
        slug: '1-bedroom-dishwasher',
        filters: {
          features: ['dishwasher'],
          bedroom_count: ['1']
        },
        rank: 690
      },
      '2-bedroom-dishwasher': {
        slug: '2-bedroom-dishwasher',
        filters: {
          features: ['dishwasher'],
          bedroom_count: ['2']
        },
        rank: 690
      },
      '3-bedroom-dishwasher': {
        slug: '3-bedroom-dishwasher',
        filters: {
          features: ['dishwasher'],
          bedroom_count: ['3']
        },
        rank: 690
      },
      '4-bedroom-dishwasher': {
        slug: '4-bedroom-dishwasher',
        filters: {
          features: ['dishwasher'],
          bedroom_count: ['4+']
        },
        rank: 690
      },
      'apartments-parking': {
        slug: 'apartments-parking',
        filters: {
          features: ['parking'],
          ...APARTMENT
        },
        rank: 495
      },
      'houses-parking': {
        slug: 'houses-parking',
        filters: {
          features: ['parking'],
          ...HOUSE
        },
        rank: 495
      },
      'townhouses-parking': {
        slug: 'townhouses-parking',
        filters: {
          features: ['parking'],
          ...TOWNHOUSE
        },
        rank: 495
      },
      'rooms-parking': {
        slug: 'rooms-parking',
        filters: {
          features: ['parking'],
          ...ROOM
        },
        rank: 495
      },
      'studios-parking': {
        slug: 'studios-parking',
        filters: {
          features: ['parking'],
          bedroom_count: ['0']
        },
        rank: 690
      },
      '1-bedroom-parking': {
        slug: '1-bedroom-parking',
        filters: {
          features: ['parking'],
          bedroom_count: ['1']
        },
        rank: 690
      },
      '2-bedroom-parking': {
        slug: '2-bedroom-parking',
        filters: {
          features: ['parking'],
          bedroom_count: ['2']
        },
        rank: 690
      },
      '3-bedroom-parking': {
        slug: '3-bedroom-parking',
        filters: {
          features: ['parking'],
          bedroom_count: ['3']
        },
        rank: 690
      },
      '4-bedroom-parking': {
        slug: '4-bedroom-parking',
        filters: {
          features: ['parking'],
          bedroom_count: ['4+']
        },
        rank: 690
      },
      'apartments-balcony': {
        slug: 'apartments-balcony',
        filters: {
          features: ['balcony'],
          ...APARTMENT
        },
        rank: 495
      },
      'houses-balcony': {
        slug: 'houses-balcony',
        filters: {
          features: ['balcony'],
          ...HOUSE
        },
        rank: 495
      },
      'townhouses-balcony': {
        slug: 'townhouses-balcony',
        filters: {
          features: ['balcony'],
          ...TOWNHOUSE
        },
        rank: 495
      },
      'rooms-balcony': {
        slug: 'rooms-balcony',
        filters: {
          features: ['balcony'],
          ...ROOM
        },
        rank: 495
      },
      'studios-balcony': {
        slug: 'studios-balcony',
        filters: {
          features: ['balcony'],
          bedroom_count: ['0']
        },
        rank: 690
      },
      '1-bedroom-balcony': {
        slug: '1-bedroom-balcony',
        filters: {
          features: ['balcony'],
          bedroom_count: ['1']
        },
        rank: 690
      },
      '2-bedroom-balcony': {
        slug: '2-bedroom-balcony',
        filters: {
          features: ['balcony'],
          bedroom_count: ['2']
        },
        rank: 690
      },
      '3-bedroom-balcony': {
        slug: '3-bedroom-balcony',
        filters: {
          features: ['balcony'],
          bedroom_count: ['3']
        },
        rank: 690
      },
      '4-bedroom-balcony': {
        slug: '4-bedroom-balcony',
        filters: {
          features: ['balcony'],
          bedroom_count: ['4+']
        },
        rank: 690
      },
      'apartments-gym-fitness-center': {
        slug: 'apartments-gym-fitness-center',
        filters: {
          features: ['gym'],
          ...APARTMENT
        },
        rank: 495
      },
      'houses-gym-fitness-center': {
        slug: 'houses-gym-fitness-center',
        filters: {
          features: ['gym'],
          ...HOUSE
        },
        rank: 495
      },
      'townhouses-gym-fitness-center': {
        slug: 'townhouses-gym-fitness-center',
        filters: {
          features: ['gym'],
          ...TOWNHOUSE
        },
        rank: 495
      },
      'rooms-gym-fitness-center': {
        slug: 'rooms-gym-fitness-center',
        filters: {
          features: ['gym'],
          ...ROOM
        },
        rank: 495
      },
      'studios-gym-fitness-center': {
        slug: 'studios-gym-fitness-center',
        filters: {
          features: ['gym'],
          bedroom_count: ['0']
        },
        rank: 690
      },
      '1-bedroom-gym-fitness-center': {
        slug: '1-bedroom-gym-fitness-center',
        filters: {
          features: ['gym'],
          bedroom_count: ['1']
        },
        rank: 690
      },
      '2-bedroom-gym-fitness-center': {
        slug: '2-bedroom-gym-fitness-center',
        filters: {
          features: ['gym'],
          bedroom_count: ['2']
        },
        rank: 690
      },
      '3-bedroom-gym-fitness-center': {
        slug: '3-bedroom-gym-fitness-center',
        filters: {
          features: ['gym'],
          bedroom_count: ['3']
        },
        rank: 690
      },
      '4-bedroom-gym-fitness-center': {
        slug: '4-bedroom-gym-fitness-center',
        filters: {
          features: ['gym'],
          bedroom_count: ['4+']
        },
        rank: 690
      },
      'apartments-swimming-pool': {
        slug: 'apartments-swimming-pool',
        filters: {
          features: ['pool'],
          ...APARTMENT
        },
        rank: 495
      },
      'houses-swimming-pool': {
        slug: 'houses-swimming-pool',
        filters: {
          features: ['pool'],
          ...HOUSE
        },
        rank: 495
      },
      'townhouses-swimming-pool': {
        slug: 'townhouses-swimming-pool',
        filters: {
          features: ['pool'],
          ...TOWNHOUSE
        },
        rank: 495
      },
      'rooms-swimming-pool': {
        slug: 'rooms-swimming-pool',
        filters: {
          features: ['pool'],
          ...ROOM
        },
        rank: 495
      },
      'studios-swimming-pool': {
        slug: 'studios-swimming-pool',
        filters: {
          features: ['pool'],
          bedroom_count: ['0']
        },
        rank: 690
      },
      '1-bedroom-swimming-pool': {
        slug: '1-bedroom-swimming-pool',
        filters: {
          features: ['pool'],
          bedroom_count: ['1']
        },
        rank: 690
      },
      '2-bedroom-swimming-pool': {
        slug: '2-bedroom-swimming-pool',
        filters: {
          features: ['pool'],
          bedroom_count: ['2']
        },
        rank: 690
      },
      '3-bedroom-swimming-pool': {
        slug: '3-bedroom-swimming-pool',
        filters: {
          features: ['pool'],
          bedroom_count: ['3']
        },
        rank: 690
      },
      '4-bedroom-swimming-pool': {
        slug: '4-bedroom-swimming-pool',
        filters: {
          features: ['pool'],
          bedroom_count: ['4+']
        },
        rank: 690
      },
      'apartments-wheelchair-access': {
        slug: 'apartments-wheelchair-access',
        filters: {
          features: ['disable_ready'],
          ...APARTMENT
        },
        rank: 495
      },
      'houses-wheelchair-access': {
        slug: 'houses-wheelchair-access',
        filters: {
          features: ['disable_ready'],
          ...HOUSE
        },
        rank: 495
      },
      'townhouses-wheelchair-access': {
        slug: 'townhouses-wheelchair-access',
        filters: {
          features: ['disable_ready'],
          ...TOWNHOUSE
        },
        rank: 495
      },
      'rooms-wheelchair-access': {
        slug: 'rooms-wheelchair-access',
        filters: {
          features: ['disable_ready'],
          ...ROOM
        },
        rank: 495
      },
      'studios-wheelchair-access': {
        slug: 'studios-wheelchair-access',
        filters: {
          features: ['disable_ready'],
          bedroom_count: ['0']
        },
        rank: 690
      },
      '1-bedroom-wheelchair-access': {
        slug: '1-bedroom-wheelchair-access',
        filters: {
          features: ['disable_ready'],
          bedroom_count: ['1']
        },
        rank: 690
      },
      '2-bedroom-wheelchair-access': {
        slug: '2-bedroom-wheelchair-access',
        filters: {
          features: ['disable_ready'],
          bedroom_count: ['2']
        },
        rank: 690
      },
      '3-bedroom-wheelchair-access': {
        slug: '3-bedroom-wheelchair-access',
        filters: {
          features: ['disable_ready'],
          bedroom_count: ['3']
        },
        rank: 690
      },
      '4-bedroom-wheelchair-access': {
        slug: '4-bedroom-wheelchair-access',
        filters: {
          features: ['disable_ready'],
          bedroom_count: ['4+']
        },
        rank: 690
      }
    }
  ]
}

const cheapAndLuxuryFilters = () => {
  const LUXURY = { sort: { sort_by: 'PRICE', sort_type: 'DESC' } }
  const CHEAP = { sort: { sort_by: 'PRICE', sort_type: 'ASC' } }

  return [
    {
      'luxury-apartments': {
        slug: 'luxury-apartments',
        filters: {
          ...LUXURY,
          ...APARTMENT
        },
        rank: 470
      },
      luxury: {
        slug: 'luxury',
        filters: {
          ...LUXURY
        },
        rank: 1300
      },
      'luxury-furnished-rentals': {
        slug: 'luxury-furnished-rentals',
        filters: {
          ...LUXURY,
          features: ['furnished']
        },
        rank: 1050
      },
      'luxury-short-term-rentals': {
        slug: 'luxury-short-term-rentals',
        filters: {
          ...LUXURY,
          rental_type: ['SHORT_TERM']
        },
        rank: 590
      },
      'luxury-houses': {
        slug: 'luxury-houses',
        filters: {
          ...LUXURY,
          ...HOUSE
        },
        rank: 470
      },
      'cheap-apartments': {
        slug: 'cheap-apartments',
        filters: {
          ...CHEAP,
          ...APARTMENT
        },
        rank: 470
      },
      'cheap-houses': {
        slug: 'cheap-houses',
        filters: {
          ...CHEAP,
          ...HOUSE
        },
        rank: 470
      },
      'cheap-short-term-rentals': {
        slug: 'cheap-short-term-rentals',
        filters: {
          ...CHEAP,
          rental_type: ['SHORT_TERM']
        },
        rank: 590
      },
      cheap: {
        slug: 'cheap',
        filters: {
          ...CHEAP
        },
        rank: 1300
      },
      'cheap-rooms': {
        slug: 'cheap-rooms',
        filters: {
          ...CHEAP,
          ...ROOM
        },
        rank: 470
      },
      'cheap-2-bedroom-apartments': {
        slug: 'cheap-2-bedroom-apartments',
        filters: {
          ...CHEAP,
          bedroom_count: ['2'],
          ...APARTMENT
        },
        rank: 96
      },
      'cheap-1-bedroom-apartments': {
        slug: 'cheap-1-bedroom-apartments',
        filters: {
          ...CHEAP,
          bedroom_count: ['1'],
          ...APARTMENT
        },
        rank: 96
      },
      'cheap-studio-apartments': {
        slug: 'cheap-studio-apartments',
        filters: {
          ...CHEAP,
          bedroom_count: ['0'],
          ...APARTMENT
        },
        rank: 96
      }
    }
  ]
}

const utilityFilters = () => {
  const utilities = [
    { filter: 'cable', slug: 'cable-tv' },
    { filter: 'electricity', slug: 'utilities-included' },
    { filter: 'water', slug: 'water-included' },
    { filter: 'heat', slug: 'heat-included' },
    { filter: 'gas', slug: 'gas-included' },
    { filter: 'internet', slug: 'wifi-internet-included' }
  ]

  const result = {}

  utilities.forEach(({ filter, slug }) => {
    result[slug] = {
      slug,
      filters: {
        utilities: [filter]
      },
      rank: 1500
    }
    result[`apartments-${slug}`] = {
      slug: `apartments-${slug}`,
      filters: {
        utilities: [filter],
        ...APARTMENT
      },
      rank: 495
    }
    result[`houses-${slug}`] = {
      slug: `houses-${slug}`,
      filters: {
        utilities: [filter],
        ...HOUSE
      },
      rank: 495
    }
    result[`townhouses-${slug}`] = {
      slug: `townhouses-${slug}`,
      filters: {
        utilities: [filter],
        ...TOWNHOUSE
      },
      rank: 495
    }
    result[`rooms-${slug}`] = {
      slug: `rooms-${slug}`,
      filters: {
        utilities: [filter],
        ...ROOM
      },
      rank: 495
    }
    result[`studios-${slug}`] = {
      slug: `studios-${slug}`,
      filters: {
        utilities: [filter],
        bedroom_count: ['0']
      },
      rank: 690
    }
    result[`1-bedroom-${slug}`] = {
      slug: `1-bedroom-${slug}`,
      filters: {
        utilities: [filter],
        bedroom_count: ['1']
      },
      rank: 690
    }
    result[`2-bedroom-${slug}`] = {
      slug: `2-bedroom-${slug}`,
      filters: {
        utilities: [filter],
        bedroom_count: ['2']
      },
      rank: 690
    }
    result[`3-bedroom-${slug}`] = {
      slug: `3-bedroom-${slug}`,
      filters: {
        utilities: [filter],
        bedroom_count: ['3']
      },
      rank: 690
    }
    result[`4-bedroom-${slug}`] = {
      slug: `4-bedroom-${slug}`,
      filters: {
        utilities: [filter],
        bedroom_count: ['4+']
      },
      rank: 690
    }
  })

  return [result]
}

const dealsFilters = () => {
  const deals = [
    { filter: 'special_offer', slug: 'move-in-specials' },
    { filter: 'price_drop', slug: 'price-drop' }
  ]

  const result = {}

  deals.forEach(({ filter, slug }) => {
    result[slug] = {
      slug,
      filters: {
        deals: [filter]
      },
      rank: 1600
    }
    result[`apartments-${slug}`] = {
      slug: `apartments-${slug}`,
      filters: {
        deals: [filter],
        ...APARTMENT
      },
      rank: 495
    }
    result[`houses-${slug}`] = {
      slug: `houses-${slug}`,
      filters: {
        deals: [filter],
        ...HOUSE
      },
      rank: 495
    }
    result[`townhouses-${slug}`] = {
      slug: `townhouses-${slug}`,
      filters: {
        deals: [filter],
        ...TOWNHOUSE
      },
      rank: 495
    }
    result[`rooms-${slug}`] = {
      slug: `rooms-${slug}`,
      filters: {
        deals: [filter],
        ...ROOM
      },
      rank: 495
    }
    result[`studios-${slug}`] = {
      slug: `studios-${slug}`,
      filters: {
        deals: [filter],
        bedroom_count: ['0']
      },
      rank: 690
    }
    result[`1-bedroom-${slug}`] = {
      slug: `1-bedroom-${slug}`,
      filters: {
        deals: [filter],
        bedroom_count: ['1']
      },
      rank: 690
    }
    result[`2-bedroom-${slug}`] = {
      slug: `2-bedroom-${slug}`,
      filters: {
        deals: [filter],
        bedroom_count: ['2']
      },
      rank: 690
    }
    result[`3-bedroom-${slug}`] = {
      slug: `3-bedroom-${slug}`,
      filters: {
        deals: [filter],
        bedroom_count: ['3']
      },
      rank: 690
    }
    result[`4-bedroom-${slug}`] = {
      slug: `4-bedroom-${slug}`,
      filters: {
        deals: [filter],
        bedroom_count: ['4+']
      },
      rank: 690
    }
  })

  return [result]
}

const filters = {
  rooms: {
    slug: 'rooms',
    filters: ROOM,
    rank: 505
  },
  'entire-space': {
    slug: 'entire-space',
    filters: ENTIRE_SPACE,
    rank: 505
  },
  'private-suite': {
    slug: 'private-suite',
    filters: PARTIAL_SPACE,
    rank: 505
  },
  apartments: {
    slug: 'apartments',
    filters: APARTMENT,
    rank: 500
  },
  houses: {
    slug: 'houses',
    filters: HOUSE,
    rank: 500
  },
  townhouses: {
    slug: 'townhouses',
    filters: TOWNHOUSE,
    rank: 500
  },
  basement: {
    slug: 'basement',
    filters: BASEMENT,
    rank: 500
  },
  laneway: {
    slug: 'laneway',
    filters: LANEWAY,
    rank: 500
  },
  'garden-suite': {
    slug: 'garden-suite',
    filters: GARDEN_SUITE,
    rank: 500
  },
  'verified-rentals': {
    slug: 'verified-rentals',
    filters: { search_only_verified: true },
    rank: 900
  }
}

const FILTERS = Object.assign(
  {},
  filters,
  ...bedBathFilters(),
  ...petFilters(),
  ...leaseTypeFilters(),
  ...rentalTypeFilters(),
  ...priceFilters(),
  ...featuresFilters(),
  ...amenitiesFilters(),
  ...cheapAndLuxuryFilters(),
  ...utilityFilters(),
  ...dealsFilters()
)

module.exports = { FILTERS }
